
import React, { useState, useEffect } from 'react'
import { Checkdevice, Processmoney } from '../../../../components'
import { CLEARSTYLE } from '../../../../config/cssconstants'
import 'rc-slider/assets/index.css';
import './PricelistFilterModalContent.css'
import Slider from 'rc-slider';

const Range = Slider.Range;

function PricelistFilterModalContent(props) {
    const {

        selectedwedorevent,
        reset,
        currency,
        minmaxstep,
        rangereset,
        minrange,
        maxrange

    } = props

    const [availablefilters, setAvailablefilters] = useState({})
    const [active, setActive] = useState(false)
    const [titles, setTitles] = useState([])
    const [headerbools, setHeaderbools] = useState([])
    const [headernames, setHeadernames] = useState([])
    const [modalminmax, setModalminmax] = useState([])
    const device = Checkdevice()

    useEffect(() => {
        const { availablefilters, filtersetting, selectedVendorType, modalminmax } = props
        const { Keys, active } = availablefilters[selectedVendorType]
        var headers = filtersetting[selectedVendorType]['filteritem']

        var headerbools = [] // store all the boolean state of tag
        var headernames = [] // store every single tags

        for (let i = 0; i < Keys.length; i++) {
            const key = Keys[i]
            for (let j = 0; j < availablefilters[selectedVendorType][key].length; j++) {
                const { header } = availablefilters[selectedVendorType][key][j]
                var checked = false
                if (headers.length > 0) {
                    for (let k = 0; k < headers.length; k++) {
                        if (headers[k] === header) { // check with user's filter if the header is already checked
                            checked = true
                        }
                    }
                }
                headerbools.push(checked)
                headernames.push(header)
            }
        }

        setHeaderbools([...headerbools])
        setHeadernames([...headernames])
        setTitles(Keys)
        setActive(active)
        setAvailablefilters(JSON.parse(JSON.stringify(availablefilters)))
        setModalminmax(modalminmax)

    }, [])

    const applyClick = () => {
        var checkedheaders = []
        for (let i = 0; i < headerbools.length; i++) {
            if (headerbools[i]) {
                checkedheaders.push(headernames[i])
            }
        }
        props.apply({
            checkedheadernames: [...checkedheaders],
            modalminmax: modalminmax
        })
    }

    const checkboxescontent = titles.map((title, titleindex) => {

        if (props.priceorfilter === 'FILTER' && title === 'Price') { // in FILTER portal, theres no Price category
            return null
        }

        else if (props.priceorfilter === 'PRICE' && title !== 'Price') { // in PRICE portal, theres no other category other Price
            return null
        }

        return <div key={title + titleindex} className="FMC_mainbox" >
            <div className="FMC_TITLE">{title}</div>
            <div className="FMC_BOX" >
                <div className="FMC_RESETBTNBOX">
                    <button
                        key={'clear' + titleindex}
                        style={CLEARSTYLE}
                        onClick={() => {
                            let allheaderbools = headerbools.slice()
                            for (let i = 0; i < availablefilters[props.selectedVendorType][title].length; i++) {
                                const { header } = availablefilters[props.selectedVendorType][title][i]
                                const allheaderbool_index = headernames.indexOf(header)
                                allheaderbools[allheaderbool_index] = false
                            }
                            setHeaderbools([...allheaderbools])
                        }}
                    >
                        Reset
                    </button>
                </div>
                {availablefilters[props.selectedVendorType][title].map((item, itemindex) => {
                    const { header, type } = item
                    const boolindex = headernames.indexOf(header)

                    return <div
                        key={titleindex + title + itemindex}
                        className="FMC_cbrow"
                        onClick={() => {
                            if (type === 0) {
                                let allheaderbools = headerbools.slice()
                                allheaderbools[boolindex] = !allheaderbools[boolindex]
                                setHeaderbools([...allheaderbools])

                            }
                            else if (type === 1) {
                                let allheaderbools = headerbools.slice()
                                for (let i = 0; i < availablefilters[props.selectedVendorType][title].length; i++) {
                                    const { header } = availablefilters[props.selectedVendorType][title][i]
                                    if (header !== item.header) {
                                        const allheaderbool_index = headernames.indexOf(header)
                                        allheaderbools[allheaderbool_index] = false
                                    }

                                }
                                allheaderbools[boolindex] = !allheaderbools[boolindex]
                                setHeaderbools([...allheaderbools])
                            }
                        }}
                    >
                        <input
                            className="FMC_cb"
                            type="checkbox"
                            checked={headerbools[boolindex]}
                            onChange={() => {
                                if (type === 0) {
                                    let allheaderbools = headerbools.slice()
                                    allheaderbools[boolindex] = !allheaderbools[boolindex]
                                    setHeaderbools([...allheaderbools])

                                }
                                else if (type === 1) {
                                    let allheaderbools = headerbools.slice()
                                    for (let i = 0; i < availablefilters[props.selectedVendorType][title].length; i++) {
                                        const { header } = availablefilters[props.selectedVendorType][title][i]
                                        if (header !== item.header) {
                                            const allheaderbool_index = headernames.indexOf(header)
                                            allheaderbools[allheaderbool_index] = false
                                        }

                                    }
                                    allheaderbools[boolindex] = !allheaderbools[boolindex]
                                    setHeaderbools([...allheaderbools])
                                }
                            }}
                        />
                        <label className="FMC_cblbl">{header}</label>
                    </div>
                })}
            </div>
        </div>
    })

    return active
        ? <>

            {props.priceorfilter === 'PRICE'
                ? <div key={selectedwedorevent + 'filters'} style={{ display: 'flex', flexDirection: 'column', WebkitOverflowScrolling: 'touch', }}>
                    <div className="FMC_TITLE">Price Range</div>
                    <div className="FMC_BOX">
                        <div style={{ height: 25, width: '100%', justifyContent: 'flex-end', display: 'flex' }}>
                            <button style={CLEARSTYLE} key={selectedwedorevent + 'clear'} onClick={reset} >reset</button>
                        </div>
                        <Range
                            key={'range' + rangereset}
                            style={{ margin: device === 'MOBILE' ? '20px 10px 5px' : '10px 15%' }}
                            dots={false}
                            allowCross={false}
                            marks={{}}
                            step={minmaxstep} min={minrange} max={maxrange}
                            defaultValue={modalminmax}
                            onChange={(value) => {
                                setModalminmax(value)
                            }}
                        />
                        <div className="Pricelist_filtermoneyroot">
                            <div className="Pricelist_filterdollarbox" style={{ width: device === 'MOBILE' ? "45%" : "30%" }}>
                                <div className="Pricelist_filterpricelabel">min price</div>
                                <div className="Pricelist_filterdollar">{'$ ' + Processmoney(modalminmax[0] ? modalminmax[0] : 0) + ' ' + currency}</div>
                            </div>
                            <div className="Pricelist_filterhyphen">-</div>
                            <div className="Pricelist_filterdollarbox" style={{ width: device === 'MOBILE' ? "45%" : "30%" }}>
                                <div className="Pricelist_filterpricelabel">max price</div>
                                <div className="Pricelist_filterdollar">{'$ ' + Processmoney(modalminmax[1] ? modalminmax[1] : 0) + ' ' + currency}</div>
                            </div>
                        </div>
                    </div>
                </div>
                : null}

            <div className={"FMC_ROOT" + device} style={{ placeContent: 'space-between' }}>
                {checkboxescontent}
                {device === 'MOBILE'
                    ? <div className="FMC_APPLYBTNBOX">
                        <button
                            className='Rsvpexplorer_portalsave'
                            style={{
                                position: 'relative',
                                bottom: 0,
                                backgroundColor: '#ffffff',
                                color: 'var(--maindark)',
                                border: '1px solid var(--maindark)',
                                minHeight: 45,
                                width: '100%',
                                margin: 0
                            }}
                            onClick={applyClick}
                        >
                            Apply
                        </button>
                    </div>
                    : <div className="FMC_APPLYBTNBOX">
                        <button
                            className='Rsvpexplorer_portalsave'
                            style={{
                                position: 'relative',
                                bottom: 0,
                                backgroundColor: '#ffffff',
                                color: 'var(--maindark)',
                                border: '1px solid var(--maindark)',
                                minHeight: 45,
                                width: '100%',
                                margin: 0
                            }}
                            onClick={applyClick}
                        >
                            Apply
                        </button>
                    </div>}

            </div>
        </>
        : <div className="FMC_EMPTYROOT">
            <div className="FMC_EMPTYDIV" />
            <h4>Empty</h4>
            <div className="FMC_EMPTYDIV" />
        </div>
}
export default PricelistFilterModalContent